// Import Routing Components For Linking to Web pages
import React from "react";
import { useState, useEffect } from 'react';
import apiClient from '../../services/apiClient';
import { useNavigate } from 'react-router-dom'; 
import { Link } from "react-router-dom";

function Templates() {

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const navigate = useNavigate();
    const [userId, setUserId] = useState(null);
    const [subscription, setSubscription] = useState(null);
   const [loadingSubscription, setLoadingSubscription] = useState(true);

  const getToken = () => {
    const data = localStorage.getItem("user");
    if (!data) return null;
    return JSON.parse(data).access_token;
  };
  
    useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const token = getToken();
        if (!token) return;
  
        const res = await apiClient.get(
          `/subscription/status`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        setSubscription(res.data);
      } catch (err) {
        console.error("Subscription fetch failed", err);
      } finally {
        setLoadingSubscription(false);
      }
    };
  
    fetchSubscription();
  }, []);
  
  
  const handleSubscribe = async () => {
    try {
      const token = getToken();
      if (!token) return;
  
      const res = await apiClient.post(
        `/billing/checkout`, // ✅ correct route
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      window.location.href = res.data.url;
    } catch (err) {
      console.error("Checkout error", err);
    }
  };
  
  
  const handleBilling = async () => {
    try {
      const token = getToken();
      if (!token) return;
  
      const res = await apiClient.post(
        `/stripe/billing-portal`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      window.location.href = res.data.url;
    } catch (err) {
      console.error("Billing portal error", err);
    }
  };
  
  
  const ALLOWED = ["active", "trialing"];
  const SOFT_WARN = ["past_due", "incomplete"];
  const HARD_BLOCK = ["canceled", "unpaid", "expired"];
  
  

  // The return statement contains the JSX code which is rendered and displayed on the page
  return (
    <>
      <div className='container-fluid p-lg-5 p-md-5 p-3'>
        <div className='row g-lg-0 g-md-0 g-0'>
          <div className='col-sm-12 col-md-12 col-xl-12'>
            <div className='mb-0'>
              <h3 className='mb-1'>Templates</h3>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/products' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img className='w-50' src='img/product.png' alt='PRODUCT' />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Products
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/packages' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img className='w-50' src='img/packages.png' alt='packages' />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Packages
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/contracts' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img
                    className='w-50'
                    src='img/contaracts.png'
                    alt='contaracts'
                  />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Contracts
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/invoices' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img className='w-50' src='img/invoice.png' alt='invoice' />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Invoices
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/proposals' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img className='w-50' src='img/proposel.png' alt='proposel' />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Proposals
                  </h6>
                </div>
              </Link>
            </div>
          </div>

          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link
                to='/questionnaires'
                id=''
                className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img
                    className='w-50'
                    src='img/Questionnaires.png'
                    alt='Questionnaires'
                  />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                   Questionnaires
                  </h6>
                </div>
              </Link>
            </div>
          </div>

          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link
                to='/contact-form'
                id=''
                className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img
                    className='w-50'
                    src='img/contact form.png'
                    alt='contact'
                  />
                  <h6
                    className='mb-0'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Contact Form
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='h-100 p-2'>
              <Link to='/email' id='' className='d-block px-2 py-2 p-urls2'>
                <div className='mb-4 text-center'>
                  <img className='w-50' src='img/Email.png' alt='contact' />
                  <h6
                    className='mt-3'
                    style={{ fontSize: "24px", fontWeight: 500 }}>
                    Email
                  </h6>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

     {!loadingSubscription &&
  subscription &&
  (
    HARD_BLOCK.includes(subscription.status) ||
    (
      subscription.status === "trialing" &&
      new Date(subscription.current_period_end) < new Date()
    )
  ) && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="bg-white rounded p-4 shadow"
        style={{
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
        }}
      >
        <h4 className="mb-3">Subscription Required</h4>

        <p className="text-muted">
          Your subscription is inactive.
          Please add a payment method to continue.
        </p>

        <button
          className="btn btn-danger w-100 mt-3"
          onClick={handleSubscribe}
        >
          Add Payment Method
        </button>

        <Link to="/logout" className="text-dark">
                          Logout
        </Link>

      </div>
    </div>
)}


    </>
  );
}

export { Templates }; /* ========================= We had to remove default. */
